export default function Game_Gravity() {
  return (
    <div>
      <h1>Game_Gravity Component</h1>
    </div>
  );
}
